"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_1 = require("mobx");
const _1 = require("./");
class FetchModelShelf {
    constructor(id, getModel, fetchOptions) {
        this.loader = new _1.LoaderShelf();
        this.initialLoader = new _1.InitialLoaderShelf();
        this.error = new _1.AttributeShelf(null);
        this.model = new _1.AttributeShelf(null);
        this.fetchModel = () => tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                this.loader.tryStart("Cannot fetch again. The last fetch still loading.");
                this.error.setValue(null);
                const resultModel = yield this._getModel(this.id.value);
                this.model.setValue(resultModel);
                if (this._onAfterFetch) {
                    this._onAfterFetch(resultModel);
                }
            }
            catch (e) {
                this.error.setValue(e);
                if (this._onFetchError) {
                    this._onFetchError(e);
                }
            }
            finally {
                this.initialLoader.done();
                this.loader.end();
                if (this._onFinishFetch) {
                    this._onFinishFetch();
                }
            }
        });
        this.id = new _1.AttributeShelf(id);
        this._getModel = getModel;
        if (fetchOptions) {
            this._onAfterFetch = fetchOptions.onAfterFetch;
            this._onFetchError = fetchOptions.onFetchError;
            this._onFinishFetch = fetchOptions.onFinishFetch;
        }
        mobx_1.makeAutoObservable(this);
        if (fetchOptions && fetchOptions.fetchOnConstructor) {
            this.fetchModel();
        }
    }
    get modelHasFetched() {
        return !this.loader.isLoading && this.hasModel;
    }
    get hasModel() {
        return !!this.model.value;
    }
    get fetchedModel() {
        if (this.model.value) {
            return this.model.value;
        }
        throw Error("Model doesn't contains a value.");
    }
}
exports.default = FetchModelShelf;
